import { Button, Form, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { getFetchWorkers } from "../Api/GetFetchWorkers";
import { UseAdmin } from "../hooks";

// FormRecurso component allows users to select a worker from a list
export const FormRecurso = ({ ceco, setEmpleadoAsignado, onCancel, onSend }) => {
  const [form] = Form.useForm(); // Initialize form instance
  const { brandfiMarcaId, branchFiPaisId } = UseAdmin(); // Get admin data
  const [workers, setWorkers] = useState([]); // State to hold workers list
  const [isLoading, setIsLoading] = useState(true); // State to manage loading status
  const succesButtonStyle = {
    color: "white",
    backgroundColor: "#4DBF6C",
    borderColor: "#4DBF6C",
    minWidth: "150px",
    borderRadius: "20px",
    minHeight: "38px",
  };

  // Handle change in selected worker
  const handleChangeWorker = (value, option) => {
    setEmpleadoAsignado(value);
  };

  // Fetch workers data when component mounts or dependencies change
  useEffect(() => {
    const fetchData = async () => {
      if (workers.length === 0 && branchFiPaisId && brandfiMarcaId) {
        setIsLoading(true);
        const onFailure = (error) => {
          console.log(error);
          setIsLoading(false);
        };
        const onSuccess = ({ data }) => {
          if (data?.employee) {
            const options = data.employee.map((employee) => ({
              value: employee.idEmpleado,
              label: getFullName(employee),
            }));
            setWorkers(options);
          }
          setIsLoading(false);
        };
        // Fetch workers data from API
        getFetchWorkers({
          numeroPersona: null,
          nombre: null,
          primerApellido: null,
          correo: null,
          fechaNacimiento: null,
          idNacional: null,
          idPais: branchFiPaisId,
          idMarca: brandfiMarcaId,
          idCentroCostos: ceco,
        })
          .then(onSuccess)
          .catch(onFailure);
      }
    };
    fetchData();
  }, [workers.length, branchFiPaisId, brandfiMarcaId, ceco]);

  // Show loading spinner if data is being fetched
  if (isLoading) return <Spin />;

  const handleSubmit = () => {
    form.validateFields().then(() => onSend());
  };

  return (
    <>
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          name="colaborador"
          label="Seleccione el colaborador que será asignado a la tienda"
          rules={[{ required: true, message: "Por favor seleccione un colaborador" }]}
        >
          <Select
            style={{ width: 120, textAlign: "left" }}
            dropdownStyle={{ textAlign: "left" }}
            onChange={handleChangeWorker}
            placeholder="-- Seleccione --"
            options={workers}
          />
        </Form.Item>
        <Form.Item style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
          <span
            style={{
              color: "#c7002e",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: "600",
              marginTop: 8,
              marginRight: 20,
            }}
            onClick={onCancel}
          >
            Cancelar
          </span>
          <Button style={succesButtonStyle} onClick={handleSubmit}>
            Enviar
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

function getFullName(employee) {
  const second = employee.segundoNombre ? " " + employee.segundoNombre : "";
  return employee.nombre + second + " " + employee.primerApellido + " " + employee.segundoApellido;
}
